module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-01.af308762.png";